
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Icon feather-menu","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"패스 261","d":"M1 7h18"}}),_c('path',{attrs:{"data-name":"패스 262","d":"M1 1h18"}}),_c('path',{attrs:{"data-name":"패스 263","d":"M1 13h18"}})])])
          )
        }
      }
    